import { Pill } from '@iwoca/orion';
import { PillProps } from '@iwoca/orion/lib/components/Pill/Pill';
import { Trans } from '@lingui/react/macro';
import clsx from 'clsx';
import styles from './ManagedByIwocaPill.module.css';

type TProps = {
  size?: Extract<PillProps['size'], 'small' | 'medium'>;
};
export const ManagedByIwocaPill = ({ size = 'medium' }: TProps) => {
  return (
    <Pill
      className={clsx(styles.pill, {
        [styles.small]: size === 'small',
        [styles.medium]: size === 'medium',
      })}
      data-testid="managed-by-iwoca-pill"
      size={size}
    >
      <Trans>Managed by iwoca</Trans>
    </Pill>
  );
};
